enum KeyCode {

  BACKSPACE = 8,
  TAB = 9,
  CLEAR = 12,
  ENTER = 13,
  SHIFT = 16,
  CONTROL = 17,
  ALT = 18,
  CAPS_LOCK = 20,
  ESC = 27,
  SPACE = 32,
  EXCLAMATION_POINT = 33,
  DOUBLE_QUOTES = 34,
  NUMBER_SIGN = 35,
  DOLLAR_SIGN = 36,
  PERCENT_SIGN = 37,
  AMPER_SAND = 38,
  SINGLE_QUOTE = 222,
  OPENING_PARENTHESIS = 40,
  CLOSING_PARENTHESIS = 41,
  ASTERISK = 42,
  PLUS = 43,
  COMMA = 188,
  MINUS = 45,
  DELETE_BTN = 46,
  PERIOD = 190,
  SLASH = 47,
  BRACKET_LEFT = 219,
  ZERO = 48,
  ONE = 49,
  TWO = 50,
  THREE = 51,
  FOUR = 52,
  FIVE = 53,
  SIX = 54,
  SEVEN = 55,
  EIGHT = 56,
  NINE = 57,
  COLON = 58,
  SEMICOLON = 186,
  LESS_THAN = 60,
  EQUAL = 61,
  MORE_THAN = 62,
  QUESTION_MARK = 63,
  AT_SYMBOL = 64,
  NUMPAD_COMMA = 110,
  NUMPAD_PERIOD = 194,
  NUMPAD_ZERO = 96,
  NUMPAD_ONE = 97,
  NUMPAD_TWP = 98,
  NUMPAD_THREE = 99,
  NUMPAD_FOUR = 100,
  NUMPAD_FIVE = 101,
  NUMPAD_SIX = 102,
  NUMPAD_SEVEN = 103,
  NUMPAD_EIGHT = 104,
  NUMPAD_NINE = 105,
  ARROW_LEFT = 37,
  ARROW_UP = 38,
  ARROW_RIGHT = 39,
  ARROW_DOWN = 40,
  A = 65,
  B = 66,
  C = 67,
  D = 68,
  E = 69,
  F = 70,
  G = 71,
  H = 72,
  I = 73,
  J = 74,
  K = 75,
  L = 76,
  M = 77,
  N = 78,
  O = 79,
  P = 80,
  Q = 81,
  R = 82,
  S = 83,
  T = 84,
  U = 85,
  V = 86,
  W = 87,
  X = 88,
  Y = 89,
  Z = 90,
  OPENING_BRACKET = 91,
  BACKSLASH = 92,
  CLOSING_BRACKET = 93,
  CIRCUMFLEX = 94,
  UNDERSCORE = 95,
  GRAVE_ACCENT = 192,
  a = 97,
  b = 98,
  c = 99,
  d = 100,
  e = 101,
  f = 102,
  g = 103,
  h = 104,
  i = 105,
  j = 106,
  k = 107,
  l = 108,
  m = 109,
  n = 110,
  o = 111,
  p = 112,
  q = 113,
  r = 114,
  s = 115,
  t = 116,
  u = 117,
  v = 118,
  w = 119,
  x = 120,
  y = 121,
  z = 122,
  OPENING_BRACE = 123,
  VERTICAL_BAR = 124,
  CLOSING_BRACE = 125,
  EQUIVALENCE_SIGN = 126,
  DEL = 127,
  nbsp = 25,

}

export default KeyCode;
